import { FaClock, FaHandsWash, FaMapMarkedAlt, FaCheckCircle } from 'react-icons/fa';

const features = [
  {
    id: 1,
    icon: <FaClock />, // Clock icon
    title: 'Quick Service',
    description: 'Fast and efficient laundry solutions',
  },
  {
    id: 2,
    icon: <FaHandsWash />, // Hands wash icon
    title: 'Careful Handling',
    description: 'Gentle and secure care for your garments',
  },
  {
    id: 3,
    icon: <FaMapMarkedAlt />, // Map marked icon
    title: 'Local Coverage',
    description: 'Service available in your neighborhood',
  },
  {
    id: 4,
    icon: <FaCheckCircle />, // Check circle icon
    title: 'Status Updates',
    description: 'Receive live updates on your laundry status',
  },
];

export default features;